module.exports = __webpack_public_path__ + "e1c70272e83604dc35f0c46430c50cf3.svg";